      // Ajouter automatiquement les attributs data-video-number
      const videoContainers = document.querySelectorAll('.video-container');
      videoContainers.forEach((container, index) => {
          container.setAttribute('data-video-number', index + 1);
      });
  
      function checkVideos() {
          const videoDesks = document.querySelectorAll('.video-container.--desk');
          const videoMobs = document.querySelectorAll('.video-container.--mob');
          
          videoDesks.forEach((videoDeskContainer) => {
              const videoNumber = videoDeskContainer.getAttribute('data-video-number');
              const videoDesk = videoDeskContainer.querySelector('video');
              const videoMobContainer = document.querySelector(`.video-container.--mob[data-video-number="${videoNumber}"]`);
              const videoMob = videoMobContainer ? videoMobContainer.querySelector('video') : null;
              
              const btnLiveDesk = videoDeskContainer.querySelector('.btn-video.--desk');
              const btnLiveMob = videoMobContainer ? videoMobContainer.querySelector('.btn-video.--mob') : null;
              const blocLiveVideoDesk = videoDeskContainer.querySelector('.video-container__video');
              const blocLiveVideoMob = videoMobContainer ? videoMobContainer.querySelector('.video-container__video') : null;
  
              if (videoDesk || videoMob) {
                  const flags = createFlags(); // Crée un nouvel ensemble de flags pour chaque vidéo
                  initVideoControls(videoDesk, videoMob, btnLiveDesk, btnLiveMob, blocLiveVideoDesk, blocLiveVideoMob, videoNumber, flags);
              }
          });
      }
  
      // Fonction pour créer un nouvel ensemble de flags pour chaque vidéo
      function createFlags() {
          return {
              firstClick: true,
              ignoreAutoplay: true,
              isSeeking: false,
              isManualPause: false,
              ignorePause: false
          };
      }
  
      checkVideos();
  
      function initVideoControls(videoDesk, videoMob, btnLiveDesk, btnLiveMob, blocLiveVideoDesk, blocLiveVideoMob, videoNumber, flags) {
          const currentVideo = window.innerWidth >= 1024 ? videoDesk : videoMob;
          const currentbtnLive = window.innerWidth >= 1024 ? btnLiveDesk : btnLiveMob;
          const currentBlocLiveVideo = window.innerWidth >= 1024 ? blocLiveVideoDesk : blocLiveVideoMob;
  
          function enableFullscreen() {
              currentBlocLiveVideo.classList.add('fullscreen');
              currentVideo.setAttribute('controls', 'controls');
              currentVideo.muted = false;  // Désactiver le mode muet après le premier clic
          }
  
          function disableFullscreen() {
              currentBlocLiveVideo.classList.remove('fullscreen');
              currentVideo.muted = true;
          }
  
          // Vérifie si le bouton vidéo existe avant d'ajouter l'événement
          if (currentbtnLive) {
              currentbtnLive.addEventListener('click', () => {
                  if (flags.firstClick) {
                      enableFullscreen();  // Activer le plein écran et désactiver le mode muet après le premier clic
                      flags.firstClick = false;
                      flags.ignoreAutoplay = false;
                  } else {
                      if (currentVideo.paused) {
                          currentVideo.play();
                          flags.isManualPause = false; // Pas une pause manuelle
                      } else {
                          currentVideo.pause();
                          flags.isManualPause = true;  // Pause manuelle
                      }
                  }
              });
          }
  
          // Event: play
          currentVideo.addEventListener('play', () => {
              if (!flags.ignoreAutoplay && !flags.isSeeking) enableFullscreen();
          });
  
          // Event: pause (seulement si ce n'est pas ignoré)
          currentVideo.addEventListener('pause', () => {
              if (!flags.isSeeking && !flags.ignorePause) {
                  disableFullscreen();
              }
          });
  
          // Event: seeking (début du seek)
          currentVideo.addEventListener('seeking', () => {
              flags.isSeeking = true;
              flags.ignorePause = true;  // Ignorer la pause causée par le seeking
          });
  
          // Event: seeked (fin du seek)
          currentVideo.addEventListener('seeked', () => {
              flags.isSeeking = false;
              flags.ignorePause = false;  // Ne plus ignorer la pause une fois le seek terminé
          });
  
          // Event: volume change (ignorer les pauses déclenchées par le changement de volume)
          currentVideo.addEventListener('volumechange', () => {
              flags.ignorePause = true; // Ignorer la pause temporairement lors du changement de volume
              setTimeout(() => { flags.ignorePause = false; }, 100); // Réinitialiser après un court délai
          });
  
          // Event: full screen change (ignorer les pauses causées par le changement d'état de plein écran)
          currentVideo.addEventListener('fullscreenchange', () => {
              flags.ignorePause = true; // Ignorer la pause temporairement lors du changement en plein écran
              setTimeout(() => { flags.ignorePause = false; }, 100); // Réinitialiser après un court délai
          });
      }